import { IWindowService } from "angular";
import { RouterHelper } from "../../core/router/router-helper.provider";
import { UtilityService } from "../../core/services/utility.service";
import { Transition } from "angular-ui-router";
import { HardReloadService } from "../../core/router/hard-reload.service";


export function configureExcludedAreas(routerHelper: RouterHelper, $window: IWindowService,
    hardReloadService: HardReloadService, utilityService: UtilityService, apexApiUrl: string) {
    'ngInject'
    const excludedAreas = [
        "api"
    ].filter(p => {
        if (p === "api") {
            // Exclude the /api area if the API url is the same as base href + /api
            // This check is so the app doesn't go on an infinite cycle of reloading
            // when accessing the /api area of an environment where there is no /api app on the server side
            // (eg, product uses apexapi.herbjoyent.com instead of apex.herbjoyent.com/api)
            return removeTrailingSlash($window.document.baseURI) + "/api" === removeTrailingSlash(apexApiUrl);
        }
        return true;
    });
    routerHelper.configureStates(excludedAreas.map(area => ({
        state: `${area}.**`,
        config: {
            name: `${area}.**`,
            url: `/${area}`,
            onEnter: ($transition$: Transition) => {
                'ngInject';
                hardReloadService.reload();
                // In case the page is a file download (attachment disposition), hide
                // the loading spinner and abort the transitiion so the user can continue using the site.
                utilityService.hideLoading();
                $transition$.abort();
            }
        }
    })));
}

function removeTrailingSlash(url: string) {
    return url.replace(/\/$/, "");
}
